import z from "zod/v4";
import { m } from "#/paraglide/messages";

/**
 * Mirrors the ASP.NET Identity password policy (IdentityExtensions.cs):
 * RequiredLength 8 + RequireDigit + RequireNonAlphanumeric, plus the Identity
 * defaults RequireLowercase and RequireUppercase. Keep both in sync — a policy
 * failure that only surfaces server-side reaches users as a generic
 * "registration failed" message.
 */
export const passwordRequirements = [
  {
    key: "minLength",
    label: m["validation.password.label_min_length"](),
    message: m["validation.password.min_length"](),
    test: (value: string) => value.length >= 8,
  },
  {
    key: "lowercase",
    label: m["validation.password.label_lowercase"](),
    message: m["validation.password.lowercase"](),
    test: (value: string) => /[a-z]/.test(value),
  },
  {
    key: "uppercase",
    label: m["validation.password.label_uppercase"](),
    message: m["validation.password.uppercase"](),
    test: (value: string) => /[A-Z]/.test(value),
  },
  {
    key: "digit",
    label: m["validation.password.label_digit"](),
    message: m["validation.password.digit"](),
    test: (value: string) => /[0-9]/.test(value),
  },
  {
    key: "special",
    label: m["validation.password.label_special"](),
    message: m["validation.password.special"](),
    test: (value: string) => /[^a-zA-Z0-9]/.test(value),
  },
] as const;

export const passwordRules =
  "minlength: 8; required: lower; required: upper; required: digit; required: special;";

export const passwordSchema = passwordRequirements.reduce<z.ZodType<string, string>>(
  (schema, requirement) => schema.refine(requirement.test, { message: requirement.message }),
  z.string(),
);
